"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATIENT_MERGE_RESPONSE_EXAMPLE = void 0;
exports.PATIENT_MERGE_RESPONSE_EXAMPLE = {
    id: '44444444-4444-4444-4444-444444444444',
    tenantId: '11111111-1111-1111-1111-111111111111',
    sourcePatientId: '22222222-2222-2222-2222-222222222222',
    targetPatientId: '33333333-3333-3333-3333-333333333333',
    isUnmerge: false,
    originalMergeId: null,
    status: 'COMPLETED',
    reason: 'Confirmed duplicate via IdentityResolutionCandidate review',
    matchCandidateId: null,
    initiatedBy: '99999999-9999-9999-9999-999999999999',
    initiatedAt: '2026-07-10T09:00:00.000Z',
    approvedBy: null,
    approvedAt: null,
    executedAt: '2026-07-10T09:00:05.000Z',
    completedAt: '2026-07-10T09:00:10.000Z',
    failureReason: null,
    createdAt: '2026-07-10T09:00:00.000Z',
    updatedAt: '2026-07-10T09:00:10.000Z',
};
//# sourceMappingURL=merge.response.js.map